import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import ManageSubjectsUnits from '../../../components/QuestionBank/ManageSubjectsUnits';

const ManageSubjectsUnitsPage = ({ userDetails }) => {
  const userEmail = userDetails?.email || '';

  return (
    <>
      {/* Header */}
      <div className="header bg-gradient-success pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <h1 className="text-white mb-0">Manage Subjects & Units</h1>
            <p className="text-white mt-0 mb-0">Organize subjects, units, and topics for the question bank</p>
          </div>
        </Container>
      </div>

      {/* Page content */}
      <Container className="mt--7" fluid>
        <ManageSubjectsUnits userEmail={userEmail} />
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  userDetails: state.loginAuth.userDetails
});

export default connect(mapStateToProps)(ManageSubjectsUnitsPage);
